import { Component } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { environment } from '../../environments/environment';
declare let ga: Function;

@Component({
    selector: 'app-root',
    templateUrl: '../Templates/app.component.html',
    styleUrls: ['../Styles/app.component.css']
})

export class AppComponent {

  title = 'Feniks';

  constructor(
    public router: Router) {

      this.router.events.subscribe(event => {
        if (environment.production && event instanceof NavigationEnd) {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
        }
      });
    };

}



// WEBPACK FOOTER //
// ./src/app/Components/app.component.ts